/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveOperations from './receive-operations';

export default  (operationId) => (dispatch) => {
    
    dispatch({
        type: actions.OPERATIONS_REQUEST,
    });

    if (!operationId) {
        throw 'no id provided';
    }

    return cecSdk
        .operation(operationId)
        .get()
        .then((operation) => {
            dispatch({
                type: actions.OPERATIONS_REQUEST_SUCCESS,
            });

            dispatch(receiveOperations([operation]));
            return operation;
        });
};